import React, { useContext } from 'react';
import DadosGerais from '../informacoes-gerais/dadosGerais';
import DadosExame from '../dados-exame';
import { FIELDS } from './fieldNames';
import { makeStyles } from "@material-ui/core/styles";
import Anexos from '../anexos';
import {
    SttModal,
    SttStepper,
    SttMobileStepper,
    SttHidden,
    SttTranslateHook
} from '@stt-componentes/core';
import { SttButton } from '@stt-componentes/core-v2';
import { useFormikContext } from 'formik';
import { useSignalEffect, useSignals } from '@preact/signals-react/runtime';

const useStyles = makeStyles(theme => ({
    mobileStepper: {
        marginBottom: theme.spacing(1)
    }
}));

const InformacoesGerais = (props) => {
    useSignals();
    const {
        confirmarFecharModal,
        open,
        callbackFinalizado,
        equipamentos,
        steps,
        stepAtual
    } = props;
    const classes = useStyles();

    const { strings } = useContext(SttTranslateHook.I18nContext);
    const { setFieldValue, values, touched, setTouched, validateForm } = useFormikContext();

    useSignalEffect(() => {
        if (equipamentos?.value?.length === 1) {
            setFieldValue(FIELDS.EQUIPAMENTO, equipamentos.value[0]);
        }
    });

    const proximoStep = () => {
        stepAtual.value = stepAtual.value + 1;
    }

    const stepAnterior = () => {
        stepAtual.value = stepAtual.value - 1;
    }

    const finalizarConjuntoSteps = (val) => {
        callbackFinalizado(val);
    }

    const tratarComponenteStepper = () => {
        switch (stepAtual.value) {
            case 0:
                return <DadosGerais strings={strings} equipamentos={equipamentos} />;
            case 1:
                return <DadosExame strings={strings} />;
            case 2:
                return <Anexos
                    strings={strings}
                    steps={steps}
                    validateForm={validateForm}
                    touched={touched}
                    setTouched={setTouched}
                    values={values}
                    setFieldValue={setFieldValue}
                />

        }
    }

    return (
        <SttModal
            title={strings.envioImagens}
            open={open}
            outModalClose={confirmarFecharModal}
            iconClose={confirmarFecharModal}
            maxWidth="lg"
            fullWidth={true}
            children={
                <>
                    <SttHidden only={['xs', 'sm']}>
                        <SttStepper steps={steps.map((step) => step.titulo)} activeStep={stepAtual.value} />
                        {
                            tratarComponenteStepper()
                        }
                    </SttHidden>
                    <SttHidden mdUp>
                        {
                            tratarComponenteStepper()
                        }
                        <SttMobileStepper
                            className={classes.mobileStepper}
                            steps={steps.length}
                            activeStep={stepAtual.value}
                        />
                    </SttHidden>
                </>
            }
            footer={
                <>
                    {
                        stepAtual.value > 0 &&
                        <SttButton
                            variant="outlined"
                            color="primary"
                            onClick={stepAnterior}>
                            {strings.anterior}
                        </SttButton>
                    }
                    {
                        stepAtual.value < steps.length - 1 &&
                        <SttButton
                            variant="contained"
                            color="primary"
                            onClick={() => validateForm().then((erros) => {
                                if (Object.keys(erros).length) {
                                    if (stepAtual.value === 0 && erros.equipamento) {
                                        setTouched({ ...touched, ...erros.equipamento });
                                        return;
                                    }

                                    if (stepAtual.value === 1 && erros.dadosExame) {
                                        setTouched({ ...touched, ...erros });
                                        return;
                                    }
                                }
                                proximoStep();
                            })}
                        >
                            {strings.proximo}
                        </SttButton>
                    }
                    {
                        stepAtual.value === steps.length - 1 &&
                        <SttButton
                            variant="contained"
                            color="primary"
                            onClick={finalizarConjuntoSteps}>
                            {strings.enviarExame}
                        </SttButton>
                    }
                    <SttButton
                        variant="outlined"
                        color="secondary"
                        onClick={confirmarFecharModal}
                    >
                        {strings.cancelar}
                    </SttButton>
                </>
            }
        />
    );
}

export default InformacoesGerais;